// Lists
const deviceEventTypes = {
  deviceInfo: 'deviceInfo',
  deviceCmd: 'deviceCmd',
  deviceSms: 'deviceSms',
  scenarioTrigger: 'scenarioTrigger',
  rightTrigger: 'rightTrigger',
};

const deviceEventInfoTypes = {
  timeout: 'timeout',
};

/**
* Model
*/
const deviceEvent = {
  // Name
  name: 'deviceEvent',

  // Utils
  types: deviceEventTypes,
  infoTypes: deviceEventInfoTypes,
};

module.exports = deviceEvent;



// WEBPACK FOOTER //
// ./models/deviceEvent.js